import 'bootstrap/dist/css/bootstrap.css';
import LogRocket from 'logrocket';
import React from 'react';
import ReactDOM from 'react-dom';
import ga from 'react-ga';
import { browserHistory, useRouterHistory } from 'react-router';
import * as Router from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import uuidv4 from 'uuid/v4';
import config from '../src/config';
import { browserClient } from './apollo';
import Root from './views/Root';
import configureStore from './store/configureStore';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import routes from './views/routes';

global.__TEST__ = false;
global.__CLIENT__ = true;

Sentry.init({
  dsn: "https://1cc68b0154924d22b8e9334b35cec9b1@o1097921.ingest.sentry.io/6119811",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV3Instrumentation(
        browserHistory,
        // Must be Plain Routes.
        Router.createRoutes(routes),
        Router.match
      ),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

if (process.env.NODE_ENV === 'production') {
  ga.initialize(config.analyticsId);
  LogRocket.init('2kkaeb/sight');
}

const data = {};
const dest = document.getElementById('root');
// const store = configureStore(data, apolloClient);
const store = configureStore(data);
const apolloClient = browserClient({ store });
const history = syncHistoryWithStore(browserHistory, store);

if (!sessionStorage.getItem('uuid')) {
  sessionStorage.setItem('uuid', uuidv4());
}
// const refreshNotification = async () => {
//   if (
//     ['local', 'dev', 'staging', 'production'].indexOf(process.env.NODE_ENV) > -1
//   ) {
//     const response = await apolloClient.query({
//       query: gql`
//         query version {
//           version
//         }
//       `,
//     });

//     const version = '0.0.1'; //response.data.version;
//     if (lt(versionConfig.version, version)) {
//       debugger;
//     }
//   }
// };

// const refreshTimer = setInterval(refreshNotification, 5000);

const onUpdate = () => {
  window.scrollTo(0, 0);
  const state = store.getState();
  const userId = state.auth.get('user', null);
  const firstName = state.users.getIn(['users', userId, 'first_name'], null);
  const lastName = state.users.getIn(['users', userId, 'last_name'], null);
  const email = state.users.getIn(['users', userId, 'email'], null);

  if (process.env.NODE_ENV !== 'local') {

    if (userId && process.env.NODE_ENV === 'production') {
      LogRocket.identify(userId.toString(), {
        name: [firstName, lastName].join(' '),
        firstName,
        lastName,
        email,
      });
    }
  }
  ga.set({ userId });

  if (process.env.NODE_ENV === 'production') {
    ga.pageview(window.location.pathname);
  }
};

ReactDOM.render(
  <Root
    store={store}
    history={history}
    onUpdate={onUpdate}
    client={apolloClient}
  />,
  dest,
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js